import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router";
import { canonicalHrefForPath } from "../utils/canonicalBase";

/**
 * Mirrors SSR: canonical (pathname only) + noindex, follow on auth flows.
 */
export default function AuthFlowHead({ robots = "noindex, follow" }) {
  const { pathname } = useLocation();
  return (
    <Helmet>
      <link rel="canonical" href={canonicalHrefForPath(pathname)} />
      <meta name="robots" content={robots} />
    </Helmet>
  );
}
